import * as React from "react"
import { cn } from "../../lib/utils"

const Alert = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("relative w-full rounded-lg border p-4", className)} {...props} />
))
Alert.displayName = "Alert"

const AlertDescription = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("text-sm [&_p]:leading-relaxed", className)} {...props} />
))
AlertDescription.displayName = "AlertDescription"

export { Alert, AlertDescription }